import { Form } from "antd";
import styled from "styled-components";

export const StyledForm = styled(Form)`
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    gap: 12px;
    width: 100%;
    margin-bottom: 16px;
    padding: 16px;
    background-color: ${(props) => props.theme.secondaryBackgroundColor};

    .ant-form-item {
        margin-bottom: 0;
    }
` as typeof Form;
